'use strict';

export const autocompleteElements = () => ({
    suggestionContainer: () => {
        const suggestionContainer = document.createElement('div');
        suggestionContainer.classList.add('suggestion-container');
        return suggestionContainer;
    },
    listElement: id => ( document.querySelector(`li[data-suggestion-id="${id}"]`) ),
    currentText: text => {
        const currentText = document.createElement('span');
        currentText.innerHTML = text;
        currentText.classList.add('current');
        return currentText;
    },
    suggestionList: ( suggestions, overSuggestion, suggestionDown ) => {
        const suggestionList = document.createElement('ul');
        for (let suggestion of suggestions) {
            const listElement = document.createElement('li');
            const text = document.createElement('span');
            text.innerHTML = suggestion.title;
            text.classList.add('text');
            listElement.addEventListener('mouseover', overSuggestion);
            listElement.addEventListener('mousedown', suggestionDown);
            listElement.append(text);
            listElement.setAttribute('data-suggestion-id', suggestion.id);
            suggestionList.append(listElement);
        }
        return suggestionList;
    }
});
